import { render, staticRenderFns } from "./UlList.vue?vue&type=template&id=d012436c&"
import script from "./UlList.vue?vue&type=script&lang=js&"
export * from "./UlList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports